import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableCell, TableHead, TableRow } from '@mui/material';
import colors from 'src/theme/colors';
import { useEsgTaxonomy } from 'src/Esg/hooks';

export default function Head() {
  const { t } = useTranslation('esg', {
    keyPrefix: 'taxonomy.contributions.table.headers',
  });

  const { taxonomyReport, queries } = useEsgTaxonomy();
  if (!taxonomyReport || queries.isLoading) return null;

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ bgcolor: colors.backgroundInput, width: '50%' }}>
          {t('activity')}
        </TableCell>
        <TableCell sx={{ bgcolor: colors.backgroundInput, width: '25%' }}>
          {t('turnover')}
        </TableCell>
        <TableCell sx={{ bgcolor: colors.backgroundInput, width: '25%' }}>
          {t('aligned')} {t('turnover')} ({taxonomyReport.currency_type})
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
